import type {UntypedPayload} from 'constants/events/EventPayloadUtils';
import type {TrayTaskOptions} from 'tray/TrayTaskTypes';

export const NOTIFICATIONS_EVENT_PAYLOADS = {
  TOAST_PUSH: {} as UntypedPayload,
  TOAST_CLOSE: {} as UntypedPayload,

  TRAY_TASK_ADD: {} as {
    taskId: string;
    options: TrayTaskOptions;
  },
  TRAY_TASK_UPDATE: {} as {
    taskId: string;
    options: Partial<TrayTaskOptions>;
  },
  TRAY_TASK_REMOVE: {} as {
    taskId: string;
  },
  TRAY_TASK_TOGGLE_OPEN: {} as const,
  TRAY_TASK_SHOW: {} as const,
  TRAY_TASK_HIDE: {} as const,
} as const;

export type NotificationsEventPayload = typeof NOTIFICATIONS_EVENT_PAYLOADS;
